import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/login", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId, role: "candidate" });
        localStorage.setItem("axiony_token", data.token);
        setUser(data.user);
        const dest = data.user?.role === "recruiter" ? "/recruiter" : "/candidate";
        navigate(dest, { replace: true, state: { user: data.user } });
      } catch (e) {
        navigate("/login?err=oauth", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center text-slate-400">
      <div className="mono-label">completing sign-in…</div>
    </div>
  );
};
